import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M9.83 12H11v6h2v-6h1.17L12 9.83z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 4h14v2H5zm7 3l-7 7h4v6h6v-6h4l-7-7zm1 5v6h-2v-6H9.83L12 9.83 14.17 12H13z"
})), 'PublishTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PublishTwoTone.js
// module id = 5631
// module chunks = 2